import { EditAnscNotificationsSubscriptionCrumbs } from 'subscription/constants/ansc-notifications.crumbs';
import { Fragment, ReactElement } from 'react';
import EditAnscNotificationsShared from 'shell/components/shared/ansc-notifications/edit';
import { IdAmbito } from 'shell/constants/id-ambito';

const AnscNotificationsEditPage = (): ReactElement => {
  return (
    <Fragment>
      <EditAnscNotificationsShared
        scope={IdAmbito.Iscrizioni}
        items={EditAnscNotificationsSubscriptionCrumbs()}
      />
    </Fragment>
  );
};

AnscNotificationsEditPage.displayName = 'Ansc Notification edit page component';

export default AnscNotificationsEditPage;
